import React from 'react';
import { COMPANY } from '@ApplicationWide/routes/route-groups';
import { InfoIcon } from '@Generic/icons';

const CompanyPage = React.lazy(() => import('../../../pages/Company/CompanyPage'));

export default {
  label: 'about-page.title',
  group: COMPANY,
  to: '/company/about',
  route: '/company/about',
  component: CompanyPage,
  icon: <InfoIcon />,
  appearsInNavBar: true,
  hasNavBar: true,
};
